import { all } from "redux-saga/effects"
import handlePlaySound from "./handlePlaySound"

export default function* () {
  yield all([...handlePlaySound])
}
